import { useCellSelection } from './cell-selection'
import { injectTyped } from '@/inject'
import { ServiceKeys } from '@/services/symbols'

export function useRegisterLinkClickEvent() {
  const rappidContext = injectTyped(ServiceKeys.rappidContext)

  const { highlightLink } = useCellSelection()

  function registerLinkClickEvent(): void {
    rappidContext.paper.on('link:pointerclick', highlightLink)
  }

  return { registerLinkClickEvent }
}
